import { render, staticRenderFns } from "./Annotate.vue?vue&type=template&id=788fafab"
import script from "./Annotate.vue?vue&type=script&lang=js"
export * from "./Annotate.vue?vue&type=script&lang=js"
import style0 from "./Annotate.vue?vue&type=style&index=0&id=788fafab&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports